<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs6>
        <v-title>Dealer Support Documents and Rate Sheets</v-title>
        <v-list>
          <v-list-group
            v-for="(category, cindex) in categories"
            :key="cindex"
            no-action
          >
            <v-list-tile slot="activator">
              <v-list-tile-title v-text="category"></v-list-tile-title>
            </v-list-tile>
            <v-list-group
              v-for="(heading, index) in headings"
              :key="index"
              v-if="
                rows
                  .filter((x) => x.section == heading)
                  .filter((y) => y.category == category).length > 0
              "
              false
              no-action
              sub-group
            >
              <v-list-tile slot="activator">
                <v-list-tile-title v-text="heading"></v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                v-for="(crud, i) in rows
                  .filter((x) => x.section == heading)
                  .filter((y) => y.category == category)"
                :key="i"
                @click="openItem(crud.href)"
              >
                <v-list-tile-title v-text="crud.label"></v-list-tile-title>
                <v-list-tile-action>
                  <v-icon>attachment</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list-group>
        </v-list>
      </v-flex>
      <v-flex sm12 md12 lg12>
        <message-alert :component="message"></message-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { mapActions, createNamespacedHelpers } from "vuex";
const {
  mapActions: mapDealerPortalActions,
  mapMutations: mapDealerPortalMutations,
} = createNamespacedHelpers(`orders/dealerPortal`);
import {
  mapDealerPortalFields,
  mapDealerPortalMultiRowFields,
} from "@/store/modules/orders";
import { httpError } from "@/models/httpError";
import { ResourceHeading } from "@/models/ResourceHeading";

export default {
  name: "resources-list",
  data() {
    return {
      showArchived: false,
    };
  },
  methods: {
    ...mapDealerPortalActions(["getResourceFiles"]),
    openItem: (link) => {
      if (link.includes("http")) window.open(link, "_blank");
      else window.open("https://www.vonex.com.au/" + link, "_blank");
    },
  },
  computed: {
    ...mapDealerPortalMultiRowFields(["rows"]),
    ...mapDealerPortalFields(["message"]),
    headings: function () {
      return Array.from(new Set(this.rows.map((x) => x.section)));
    },
    categories: function () {
      return Array.from(new Set(this.rows.map((x) => x.category)));
    },
  },
  mounted() {
    let vm = this;
    vm.getResourceFiles(vm.showArchived);
  },
};
</script>

<style scoped>
</style>
